import { computed, toValue } from 'vue'

import {
  getProgressModuleGranulationSettingsById,
  PROGRESS_MODULE_VIEW_GRANULATION
} from '@/utils/custom-dashboard-helper'
import { getPeriodDuration } from '@/utils/element-progress'
import { TARGET_PERIOD_ENTITY_KEYS } from '@/utils/entity-keys'
import { isBetweenDates } from '@/utils/interval'

export const PROGRESS_VIEW_PLACEMENT = 'PROGRESS_VIEW'

export const useProgressViewPeriods = ({
  periods = [],
  granulationId = PROGRESS_MODULE_VIEW_GRANULATION.WEEKLY.value
} = {}) => {
  const periodsForDisplay = computed(() => {
    return (toValue(periods) || []).map(period => {
      return {
        ...period,
        duration: getPeriodDuration(period),
        isActive: isBetweenDates(
          period[TARGET_PERIOD_ENTITY_KEYS.START_DATE],
          period[TARGET_PERIOD_ENTITY_KEYS.END_DATE]
        )
      }
    })
  })

  const oneDayWidth = computed(() => {
    const granulationSettings = getProgressModuleGranulationSettingsById({
      granulationId: toValue(granulationId)
    })

    return granulationSettings.oneDayWidth
  })

  const minWidth = computed(() => {
    const totalDuration = periodsForDisplay.value.reduce((acc, val) => acc + val.duration, 0)

    const totalDurationWidth = totalDuration * oneDayWidth.value

    return `${totalDurationWidth}px`
  })

  return { periodsForDisplay, oneDayWidth, minWidth }
}

export const PROGRESS_VIEW_DEFAULT_COLUMN_COUNT = 6

export const PROGRESS_VIEW_COLUMN_COUNT_OPTIONS = [4, 5, 6, 7, 8]
